export default function mixin(target, source) {

  target = target.prototype;
  source = source.prototype;

  Object.getOwnPropertyNames(source).forEach(function (name) {
    if (name !== "constructor") {
      let source_property = Object.getOwnPropertyDescriptor(source, name);
      Object.defineProperty(target, name, source_property);
    }
  });
}


/** WEBPACK FOOTER **
 ** ./src/common/mixin.js
 **/